const STORAGE_KEYS = {
  DJ_AUTHN_ACCESS_TOKEN: 'dj_authn_access_token',
  DJ_ACCESS_TOKEN: 'dj_access_token',
  DJ_REFRESH_TOKEN: 'dj_refresh_token',
  DJ_NONCE: 'dj_oauth_nonce',
  OKTA_TOKEN: 'okta-token-storage',
};

export const setItem = (key: string, value: string) => localStorage.setItem(key, value);
export const getItem = (key: string): string | null => localStorage.getItem(key);
export const removeItem = (key: string) => localStorage.removeItem(key);
export const clearAuthStorage = () => {
  removeItem(STORAGE_KEYS.DJ_AUTHN_ACCESS_TOKEN);
  removeItem(STORAGE_KEYS.DJ_ACCESS_TOKEN);
  removeItem(STORAGE_KEYS.DJ_REFRESH_TOKEN);
  removeItem(STORAGE_KEYS.OKTA_TOKEN);
};

export { STORAGE_KEYS };

export const getTokenFromLocalStorage = () => {
  const oktaTokenItem = getItem(STORAGE_KEYS.OKTA_TOKEN);
  const djAccessToken = getItem(STORAGE_KEYS.DJ_ACCESS_TOKEN);

  if (oktaTokenItem) {
    const parsedObject = JSON.parse(oktaTokenItem);
    if (parsedObject?.accessToken?.accessToken) return parsedObject.accessToken.accessToken;
  }

  if (djAccessToken) {
    return djAccessToken;
  }

  return '';
};

const timeFilterItemName = 'time-filter-storage';

export const getTimeFilterModalPreference = () => {
  return localStorage.getItem(timeFilterItemName);
};

export const setTimeFilterModalPreference = () => {
  return localStorage.setItem(timeFilterItemName, 'true');
};
